// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3OOgA","header":"Messages_header__Opg4Y"};